import styled from "styled-components";

const PartnersPageStyled = styled.div`

`;

export default PartnersPageStyled;